// extracted by mini-css-extract-plugin
export default {"Settings":"Settings_Settings__HypTf","Head":"Settings_Head__cPLHX","Title":"Settings_Title__rWSPs","Btn":"Settings_Btn__qc92L"};